import React from 'react'
import MessageBanner from 'LuxKit/Banners/MessageBanner'

interface Props {
  saleUnit: string
}

function InvalidSelectionBanner({ saleUnit }: Props) {
  return (
    <MessageBanner
      kind="warning"
      density="compact"
    >
      Your previous {saleUnit} selection is no longer available, please review your new selection.
    </MessageBanner>
  )
}

export default InvalidSelectionBanner
